import { isNonNullableObject } from "@knyt/artisan";
export function isUnescapedString(value) {
    return (isNonNullableObject(value) &&
        "__isUnescapedString" in value &&
        value.__isUnescapedString === true);
}
export function createUnescapedString(value) {
    return {
        __isUnescapedString: true,
        toString: () => value,
    };
}
